import { useNavigate } from 'react-router';
import { Box, Typography, PanelCard, Button, GLPGrid } from '@glplus/glpweb-dsl';
import { useTranslation } from 'react-i18next';
import { useVendor } from '../../lib/CapabilitiesContext';

const CARDS = [
  { key: 'profile', to: '/business/profile', capability: 'profile:edit', accent: '#25862D' },
  { key: 'team', to: '/business/team', capability: 'team:manage', accent: '#343F5B' },
  { key: 'contacts', to: '/business/contacts', capability: 'support:manage', accent: '#F67A1A' },
  { key: 'certifications', to: '/business/certifications', capability: 'certification:manage', accent: '#25862D' },
  { key: 'ownership', to: '/business/ownership', capability: 'ownership:request', accent: '#343F5B' },
] as const;

export default function BusinessHome() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { activeMembership, has } = useVendor();
  const visible = CARDS.filter((card) => has(card.capability));
  return (
    <Box data-testid="business-home" sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 1040 }}>
      <Box>
        <Typography component="h1" variant="h4" sx={{ fontWeight: 800 }}>{t('business.title')}</Typography>
        <Typography sx={{ color: 'text.secondary', mt: 0.5 }}>{t('business.subtitle', { role: t(`team.role${capitalize(activeMembership?.role ?? 'clerk')}`) })}</Typography>
      </Box>
      <GLPGrid container spacing={2}>
        {visible.map((card) => (
          <GLPGrid key={card.key} size={{ xs: 12, md: 6 }}>
            <PanelCard title={t(`business.cards.${card.key}.title`)} accent={card.accent} sx={{ height: '100%', bgcolor: '#fff' }}>
              <Typography sx={{ color: 'text.secondary', mb: 2 }}>{t(`business.cards.${card.key}.body`)}</Typography>
              <Button ariaLabel={t(`business.cards.${card.key}.action`)} buttonText={t(`business.cards.${card.key}.action`)} variant="outlinedOrange" size="small" onClick={() => navigate(card.to)} />
            </PanelCard>
          </GLPGrid>
        ))}
      </GLPGrid>
    </Box>
  );
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
